import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Renders when the URL hash contains `session_id=...` — exchanges it with
 * the backend, then removes the hash and returns the user to `/`.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : "";
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id: sid },
          { withCredentials: true }
        );
        await refresh();
        toast.success("Signed in with Google");
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
      } finally {
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center text-zinc-900">
      <div className="text-center">
        <div className="font-mono-plex text-[10px] font-semibold text-zinc-500 mb-2">
          COMPLETING SIGN-IN
        </div>
        <div className="font-display text-2xl text-zinc-950">One moment…</div>
      </div>
    </div>
  );
}
